import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=711ff630&scoped=true&"
import script from "./AttributesTable.vue?vue&type=script&lang=js&"
export * from "./AttributesTable.vue?vue&type=script&lang=js&"
import style0 from "./AttributesTable.vue?vue&type=style&index=0&id=711ff630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ff630",
  null
  
)

export default component.exports